(function () {
    "use strict";


    const DEFAULT_STYLE =
        "photomark";


    const CONFIG_SELECTOR =
        ".fr-artifactConfig";


    const IMAGE_CARD_SELECTOR =
        ".kg-image-card";


    const PHOTOMARK_INLINE_DIRECTIVE =
        "PHOTOMARKINLINE:";


    const PHOTO_INLINE_DIRECTIVE =
        "PHOTOINLINE:";


    const MAX_INLINE_DIRECTIVE_LOOKBACK =
        8;


    /* ======================================================
       TEXT HELPERS
       ========================================================== */

    function normalizeDirectiveText(
        value
    ) {
        return String(
            value ||
            ""
        )
            .replace(
                /\u00a0/g,
                " "
            )
            .replace(
                /[\u200B\u200C\u200D\uFEFF]/g,
                ""
            )
            .replace(
                /\s+/g,
                ""
            )
            .trim()
            .toUpperCase();
    }


    function hasMeaningfulContent(
        element
    ) {
        if (!element) {
            return false;
        }


        const text =
            String(
                element.textContent ||
                ""
            )
                .replace(
                    /\u00a0/g,
                    " "
                )
                .replace(
                    /[\u200B\u200C\u200D\uFEFF]/g,
                    ""
                )
                .trim();


        if (text) {
            return true;
        }


        return Boolean(
            element.querySelector(
                [
                    "img",
                    "picture",
                    "video",
                    "audio",
                    "iframe",
                    "svg",
                    "canvas",
                    "table"
                ].join(
                    ","
                )
            )
        );
    }


    /* ======================================================
       INLINE DIRECTIVE LOOKUP

       Ghost may place empty paragraphs or wrapper elements
       between an authoring directive and the image card.

       Walk backward over empty elements, but stop immediately
       if we encounter ordinary visible content.
       ========================================================== */

    function getInlineDirectiveMarker(
        imageCard
    ) {
        let candidate =
            imageCard &&
            imageCard.previousElementSibling
                ? imageCard.previousElementSibling
                : null;


        let inspected =
            0;


        while (
            candidate &&
            inspected <
            MAX_INLINE_DIRECTIVE_LOOKBACK
            ) {
            inspected +=
                1;


            const directiveText =
                normalizeDirectiveText(
                    candidate.textContent
                );


            if (
                directiveText ===
                PHOTOMARK_INLINE_DIRECTIVE
            ) {
                return {
                    element:
                    candidate,

                    style:
                        "photomarkInline"
                };
            }


            if (
                directiveText ===
                PHOTO_INLINE_DIRECTIVE
            ) {
                return {
                    element:
                    candidate,

                    style:
                        "photoInline"
                };
            }


            /*
             * Empty Ghost paragraphs/wrappers are allowed
             * between the directive and its image.
             */

            if (
                hasMeaningfulContent(
                    candidate
                )
            ) {
                return null;
            }


            candidate =
                candidate
                    .previousElementSibling;
        }


        return null;
    }


    /* ======================================================
       INLINE DIRECTIVES
       ========================================================== */

    function getInlineDirectiveStyle(
        imageCard
    ) {
        const marker =
            getInlineDirectiveMarker(
                imageCard
            );


        if (!marker) {
            return null;
        }


        const markerElement =
            marker.element;


        /*
         * Remove empty bridge elements between the directive
         * and the image as well. They served only as Ghost
         * editing/layout residue.
         */

        let bridge =
            markerElement
                .nextElementSibling;


        while (
            bridge &&
            bridge !==
            imageCard
            ) {
            const nextBridge =
                bridge
                    .nextElementSibling;


            if (
                !hasMeaningfulContent(
                    bridge
                )
            ) {
                bridge.remove();
            }


            bridge =
                nextBridge;
        }


        markerElement.remove();


        return marker.style;
    }


    /* ======================================================
       HTML-CARD ARTIFACT CONFIGURATION
       ========================================================== */

    function getConfigMarker(
        imageCard
    ) {
        let previousElement =
            imageCard
                .previousElementSibling;


        let inspected =
            0;


        while (
            previousElement &&
            inspected <
            MAX_INLINE_DIRECTIVE_LOOKBACK
            ) {
            inspected +=
                1;


            if (
                previousElement.matches(
                    CONFIG_SELECTOR
                )
            ) {
                return previousElement;
            }


            const nestedMarker =
                previousElement.querySelector(
                    CONFIG_SELECTOR
                );


            if (nestedMarker) {
                return nestedMarker;
            }


            if (
                hasMeaningfulContent(
                    previousElement
                )
            ) {
                return null;
            }


            previousElement =
                previousElement
                    .previousElementSibling;
        }


        return null;
    }


    function getHtmlCardConfiguredStyle(
        imageCard
    ) {
        const configMarker =
            getConfigMarker(
                imageCard
            );


        if (!configMarker) {
            return null;
        }


        const configuredStyle =
            configMarker.dataset &&
            configMarker.dataset.style
                ? configMarker.dataset.style.trim()
                : "";


        const configCard =
            configMarker.closest(
                ".kg-html-card"
            );


        if (configCard) {
            configCard.remove();

        } else {
            configMarker.remove();
        }


        return (
            configuredStyle ||
            null
        );
    }


    /* ======================================================
       RESOLVE ARTIFACT STYLE
       ========================================================== */

    function getConfiguredStyle(
        imageCard
    ) {
        const inlineDirectiveStyle =
            getInlineDirectiveStyle(
                imageCard
            );


        if (
            inlineDirectiveStyle
        ) {
            return inlineDirectiveStyle;
        }


        const htmlCardStyle =
            getHtmlCardConfiguredStyle(
                imageCard
            );


        if (
            htmlCardStyle
        ) {
            return htmlCardStyle;
        }


        return DEFAULT_STYLE;
    }


    /* ======================================================
       PHOTO MODAL
       ========================================================== */

    function openArtifactPhoto(
        imageCard
    ) {
        const sourceImage =
            imageCard.querySelector(
                "img"
            );


        if (!sourceImage) {
            return;
        }


        if (
            !window.artifactsModal ||
            typeof window.artifactsModal.open !==
            "function"
        ) {
            console.warn(
                "Artifacts modal is not available."
            );


            return;
        }


        const imageSource =
            sourceImage.currentSrc ||
            sourceImage.src;


        const captionElement =
            imageCard.querySelector(
                "figcaption"
            );


        const caption =
            captionElement
                ? captionElement.textContent.trim()
                : "";


        window.artifactsModal.open({
            src:
            imageSource,

            alt:
                sourceImage.alt ||
                "",

            caption:
            caption,

            trigger:
            imageCard
        });
    }


    /* ======================================================
       PHOTO INTERACTION

       Shared by:
       - photomark
       - photomarkInline
       - photoInline
       ========================================================== */

    function initPhotoInteraction(
        imageCard
    ) {
        if (
            imageCard.dataset
                .artifactPhotoInteractionReady ===
            "true"
        ) {
            return;
        }


        imageCard.dataset
            .artifactPhotoInteractionReady =
            "true";


        imageCard.setAttribute(
            "title",
            "Click to view photograph"
        );


        imageCard.setAttribute(
            "role",
            "button"
        );


        imageCard.setAttribute(
            "tabindex",
            "0"
        );


        imageCard.setAttribute(
            "aria-label",
            "View photograph"
        );


        imageCard.addEventListener(
            "click",
            function (event) {
                event.preventDefault();


                openArtifactPhoto(
                    imageCard
                );
            }
        );


        imageCard.addEventListener(
            "keydown",
            function (event) {
                if (
                    event.key !==
                    "Enter" &&
                    event.key !==
                    " "
                ) {
                    return;
                }


                event.preventDefault();


                openArtifactPhoto(
                    imageCard
                );
            }
        );
    }


    /* ======================================================
       PHOTO INLINE ORIENTATION
       ========================================================== */

    function applyPhotoInlineOrientation(
        imageCard
    ) {
        const image =
            imageCard.querySelector(
                "img"
            );


        if (!image) {
            return;
        }


        const updateOrientation =
            function () {
                const width =
                    image.naturalWidth;


                const height =
                    image.naturalHeight;


                if (
                    !width ||
                    !height
                ) {
                    return;
                }


                const isPortrait =
                    height >
                    width;


                imageCard.classList.toggle(
                    "fr-artifact--photoInlinePortrait",
                    isPortrait
                );


                imageCard.dataset
                    .artifactPhotoOrientation =
                    isPortrait
                        ? "portrait"
                        : (
                            width ===
                            height
                                ? "square"
                                : "landscape"
                        );
            };


        if (
            image.complete &&
            image.naturalWidth &&
            image.naturalHeight
        ) {
            updateOrientation();


            return;
        }


        if (
            image.dataset
                .artifactOrientationListenerReady ===
            "true"
        ) {
            return;
        }


        image.dataset
            .artifactOrientationListenerReady =
            "true";


        image.addEventListener(
            "load",
            updateOrientation,
            {
                once:
                    true
            }
        );
    }


    /* ======================================================
       STYLE HELPERS
       ========================================================== */

    function isPhotoStyle(
        style
    ) {
        return (
            style ===
            "photomark" ||
            style ===
            "photomarkInline" ||
            style ===
            "photoInline"
        );
    }


    /* ======================================================
       APPLY ARTIFACT STYLE
       ========================================================== */

    function applyArtifactStyle(
        imageCard
    ) {
        if (
            imageCard.classList.contains(
                "fr-artifact"
            )
        ) {
            return;
        }


        const style =
            getConfiguredStyle(
                imageCard
            );


        imageCard.classList.add(
            "fr-artifact",
            `fr-artifact--${style}`
        );


        imageCard.dataset
            .artifactStyle =
            style;


        if (
            isPhotoStyle(
                style
            )
        ) {
            initPhotoInteraction(
                imageCard
            );
        }


        if (
            style ===
            "photoInline"
        ) {
            applyPhotoInlineOrientation(
                imageCard
            );
        }
    }


    /* ======================================================
       INITIALIZATION
       ========================================================== */

    function initArtifacts(
        root
    ) {
        root =
            root ||
            document;


        if (
            !root ||
            typeof root.querySelectorAll !==
            "function"
        ) {
            return;
        }


        const imageCards =
            root.querySelectorAll(
                `${IMAGE_CARD_SELECTOR}:not(.fr-artifact)`
            );


        imageCards.forEach(
            applyArtifactStyle
        );


        root
            .querySelectorAll(
                ".fr-artifact--photomark, " +
                ".fr-artifact--photomarkInline, " +
                ".fr-artifact--photoInline"
            )
            .forEach(
                initPhotoInteraction
            );


        root
            .querySelectorAll(
                ".fr-artifact--photoInline"
            )
            .forEach(
                applyPhotoInlineOrientation
            );
    }


    /* ======================================================
       PUBLIC API
       ========================================================== */

    window.FremontArtifacts = {
        init:
        initArtifacts
    };


    /* ======================================================
       AUTO INIT
       ========================================================== */

    if (
        document.readyState ===
        "loading"
    ) {
        document.addEventListener(
            "DOMContentLoaded",
            function () {
                initArtifacts(
                    document
                );
            },
            {
                once:
                    true
            }
        );

    } else {
        initArtifacts(
            document
        );
    }

})();
